import React, {useEffect, useRef} from "react";
import {Box, Toolbar} from "@mui/material";
import {useAuthsState} from "../auths/authsContext";
import {resurrectOnce} from "../operations/ressurect/resurrectFileUploadOperations";
import {useAppDispatch} from "./AppContext";

// Static style objects defined at module scope — never recreated on re-render.
const rootStyle = {
    width: "100dvw",
    height: "100dvh",
    display: "flex",
    flexDirection: "column",
    alignItems: 'stretch',
    justifyContent: 'stretch',
};

const containerSx = {
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'stretch',
    flexGrow: '1',
};

export const AppContent = ({children}) => {
    const toolbarRef = useRef();

    const appDispatch = useAppDispatch();
    const {userIsAuthenticated, userData, museumCollections} = useAuthsState();

    useEffect(() => {
        if (!userIsAuthenticated || !userData || !museumCollections || museumCollections.length === 0) {
            return;
        }
        resurrectOnce(userIsAuthenticated, userData, museumCollections, appDispatch).then();
    }, [userIsAuthenticated, userData, museumCollections, appDispatch]);

    useEffect(() => {
        if (toolbarRef.current) {
            // toolbarHeight was previously passed to makeStyles for dynamic layout;
            // kept here in case it is needed again in the future.
            // setToolbarHeight(toolbarRef.current['clientHeight']);
        }
    }, []);

    return (
        <div style={rootStyle}>
            <Toolbar ref={toolbarRef}/>
            <Box sx={containerSx}>
                {children}
            </Box>
        </div>
    );
};
